module.exports = __webpack_public_path__ + "img/1945.632249d2.gif";